<template>
  <span>{{ formattedLocation }}</span>
</template>

<script setup lang="ts">
import { computed, toRef } from 'vue'
import { useLocationQuery } from '@/api/locations'

interface Props {
  value?: number | undefined
}

const props = defineProps<Props>()
const locationIdRef = toRef(props, 'value')

const { data: location } = useLocationQuery(locationIdRef)

const formattedLocation = computed<string>(() => {
  if (location.value?.location) return location.value?.location as string
  return ''
})
</script>

<style scoped></style>
